import axios from 'axios';
import CONFIG from '../config';

export const getHomeContent = () => axios.get(`${CONFIG.API_BASE}/xapi/content/get/home`).then(res => res.data);
